module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp12_0.7450d4c2.png";